import { IUpdateIndicadorObraUseCase } from "../../../presentation/useCases/update/update_indicador_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateIndicadorObraUseCase
 */

export class UpdateIndicadorObraUseCase implements IUpdateIndicadorObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateIndicadorObra(
    idObraIndicador: number,
    resultado: string | null,
  ): Promise<void> {
    await this.repository.updateIndicadorObra(
      idObraIndicador,
      resultado,
    );
  }
}
